import { render, staticRenderFns } from "./articleForm.vue?vue&type=template&id=cc53548e&scoped=true&lang=pug"
import script from "./articleForm.vue?vue&type=script&lang=js"
export * from "./articleForm.vue?vue&type=script&lang=js"
import style0 from "./articleForm.vue?vue&type=style&index=0&id=cc53548e&prod&lang=css"
import style1 from "./articleForm.vue?vue&type=style&index=1&id=cc53548e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc53548e",
  null
  
)

export default component.exports